import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ConversionData } from 'src/app/models/conversion.model';
import { NbStepperComponent } from '@nebular/theme';

@Component({
  selector: 'app-convert',
  templateUrl: './convert.component.html',
  styleUrls: ['./convert.component.scss'],
})
export class ConvertComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper')
  stepper: NbStepperComponent;

  console = console;

  conversionData: ConversionData = {
    parserId: null,
    parserDisplay: null,
    files: [],
    convertedFiles: [],
  };

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    // Prevent click events - use manual next/prev buttons (Nebula have not got a disabled directive for the stepper yet)
    const header = document.getElementById('stepper').getElementsByClassName('header')[0] as HTMLDivElement;
    header.style.pointerEvents = 'none';
  }
}
